import {Types} from 'mongoose';
import * as dis2 from '../../dispossitions/dispossitions.data';
import {ACTIVITY_TYPE_CMC_DEVOLOPMENT} from '../activity-type.const';
import {DONATION, GRANT_AWARD, OTHER_FEE} from '../payamnets.data';
import {
    ACTIVITY_TYPE_FUNDRAISING,
    ACTIVITY_TYPE_FUNDRAISING_ID,
    ACTIVITY_TYPE_GRANT_MANAGEMENT,
    ACTIVITY_TYPE_GRANT_MANAGEMENT_ID,
    ACTIVITY_TYPE_GRANT_RESEARCH,
    ACTIVITY_TYPE_GRANT_RESEARCH_ID,
    ACTIVITY_TYPE_GRANT_WRITING,
    ACTIVITY_TYPE_GRANT_WRITING_ID,
    ACTIVITY_TYPE_OD_OTHER,
    ACTIVITY_TYPE_OD_OTHER_ID,
    ORGANIZATIONAL_DEVELOPMENT_ID,
} from './organizational-development.const';

export const GRANT_MA = {
    _id: new Types.ObjectId(ACTIVITY_TYPE_GRANT_MANAGEMENT_ID),
    label: ACTIVITY_TYPE_GRANT_MANAGEMENT,
    defaultDisposition: dis2.OD_GM_ONGOING,
    dispositions: [dis2.OD_GM_ONGOING, dis2.OD_GM_CLOSED],
    paymentIn: [GRANT_AWARD, OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const FUND_RA = {
    _id: new Types.ObjectId(ACTIVITY_TYPE_FUNDRAISING_ID),
    label: ACTIVITY_TYPE_FUNDRAISING,
    dispositions: [dis2.OD_FR_PLANNING, dis2.OD_FR_ONGOING, dis2.OD_FR_CLOSED],
    defaultDisposition: dis2.OD_FR_PLANNING,
    paymentIn: [DONATION, OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const ORGANIZATIONAL_DEVELOPMENT = {
    _id: new Types.ObjectId(ORGANIZATIONAL_DEVELOPMENT_ID),
    label: ACTIVITY_TYPE_CMC_DEVOLOPMENT,
    icon: 'organizationalDevelopment',
    description: 'Activities related to raising funds for the CMC',
    subTypes: [
        {
            _id: new Types.ObjectId(ACTIVITY_TYPE_GRANT_WRITING_ID),
            label: ACTIVITY_TYPE_GRANT_WRITING,
            defaultDisposition: dis2.OD_GW_INPROCESS,
            dispositions: [dis2.OD_GW_INPROCESS, dis2.OD_GW_SUBMITTED, dis2.OD_GW_ACCEPTED, dis2.OD_GW_REJECTED],
            paymentIn: [GRANT_AWARD, OTHER_FEE],
            paymentOut: [OTHER_FEE],
        },
        {
            _id: new Types.ObjectId(ACTIVITY_TYPE_GRANT_RESEARCH_ID),
            label: ACTIVITY_TYPE_GRANT_RESEARCH,
            dispositions: [dis2.OD_GR_ONGOING, dis2.OD_GR_COMPLETED],
            defaultDisposition: dis2.OD_GR_ONGOING,
            paymentIn: [GRANT_AWARD, OTHER_FEE],
            paymentOut: [OTHER_FEE],
        },
        GRANT_MA,
        FUND_RA,
        {
            _id: new Types.ObjectId(ACTIVITY_TYPE_OD_OTHER_ID),
            label: ACTIVITY_TYPE_OD_OTHER,
            defaultDisposition: dis2.OD_OTH_ONGOING,
            dispositions: [dis2.OD_OTH_ONGOING, dis2.OD_OTH_CLOSED, dis2.OD_OTH_OTHER],
            paymentIn: [OTHER_FEE],
            paymentOut: [OTHER_FEE],
        },
    ],
};
